import {
  Component,
  OnInit,
  Input,
  EventEmitter,
  Output,
  OnChanges,
  SimpleChanges,
  ChangeDetectionStrategy,
  AfterContentInit,
  AfterViewInit,
} from '@angular/core';
import { ElasticQuery } from 'app/interfaces/elastic-query.model';

@Component({
  selector: 'app-filter-bar',
  templateUrl: './filter-bar.component.html',
  styleUrls: ['./filter-bar.component.scss'],
  // changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FilterBarComponent implements OnInit {
  @Input() aggregations: any[] = [];
  @Output() filterChange: EventEmitter<void> = new EventEmitter<void>();
  @Input() filters: any;

  constructor() {}

  ngOnInit() {}

  buildBody(e: ElasticQuery) {
    this.filters.filters[e.Field] = e;
    this.filterChange.emit();
  }

  // Temp fake categories
  get categorizedAggregations() {
    const grouped = this.aggregations.reduce((objectsByKeyValue, obj) => {
      const value = obj.Meta.category;
      objectsByKeyValue[value] = (objectsByKeyValue[value] || []).concat(obj);
      return objectsByKeyValue;
    }, {});

    return Object.keys(grouped).map(a => ({ category: a, items: grouped[a] }));
  }

  trackByMethod(index: number, el: any): number {
    return el?.id || index;
  }

  getKeys(obj) {
    return Object.keys(obj);
  }

  log(a) {
    console.log(a);
  }

  totalSelected(items) {
    return items.map(item => item?.selectedValues?.length || 0).reduce((prev, curr) => prev + curr, 0);
  }

  categoryTotal(all) {
    const allSelected = all.map(cat => cat.items.map(item => item?.selectedValues?.length || 0)).flat();
    return allSelected.reduce((a, b) => a + b, 0);
  }

  clearFilters() {
    this.filters.filters = {};
    this.filterChange.emit();
  }
}
